import { Sparkles, XClose } from '@/assets/icons'
import { InlineTextButton } from '@/components/inline-text-button/InlineTextButton'
import { CaseStatusCheckedLabel } from './CaseStatusCheckedLabel'
import { CaseStatusTag } from './CaseStatusTag'
import { isCheckedCaseStatus, isDisplayableCaseStatus } from '../schema/case-status-schema'

export type CaseSummaryTooltipContentProps = {
  title: string
  shortSummary?: string | null
  caseStatus?: string | null
  onViewReference: () => void
  onViewCitationAnalysis: () => void
  onDismiss?: () => void
}

/** Caselaw hover content shared by chat citations and mapped opinion citations. */
export function CaseSummaryTooltipContent({
  title,
  shortSummary,
  caseStatus,
  onViewReference,
  onViewCitationAnalysis,
  onDismiss,
}: CaseSummaryTooltipContentProps) {
  return (
    <div className="max-w-xs xs:max-w-md text-sm leading-5 tracking-[-0.15px] font-normal text-brand-neutral-950">
      <div className="flex items-start justify-between gap-3">
        <div>
          <InlineTextButton onClick={onViewReference} className="compatible-word-break whitespace-pre-wrap">
            {title}
          </InlineTextButton>
        </div>
        {onDismiss && (
          <button
            type="button"
            aria-label="Close case summary"
            onClick={onDismiss}
            className="shrink-0 rounded p-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand-500"
          >
            <XClose aria-hidden="true" className="size-4" />
          </button>
        )}
      </div>
      {shortSummary && (
        <div className="mt-3">
          <div className="mb-1 flex items-center gap-1 text-xs font-semibold text-brand-neutral-700">
            <Sparkles aria-hidden="true" className="size-4 [&_path]:fill-current" />
            Case Summary
          </div>
          <p className="whitespace-pre-wrap compatible-word-break">{shortSummary}</p>
        </div>
      )}
      {isDisplayableCaseStatus(caseStatus) && (
        <div className="mt-3 flex">
          <button
            type="button"
            onClick={onViewCitationAnalysis}
            className="inline-flex cursor-pointer rounded focus:outline-hidden focus-visible:ring-2 focus-visible:ring-brand-500"
          >
            {isCheckedCaseStatus(caseStatus) ? (
              <CaseStatusCheckedLabel label="No negative or cautionary treatment detected." size="default" />
            ) : (
              <CaseStatusTag status={caseStatus} />
            )}
          </button>
        </div>
      )}
    </div>
  )
}
